import { render, staticRenderFns } from "./IconLibrary.vue?vue&type=template&id=2dcf142e"
import script from "./IconLibrary.vue?vue&type=script&lang=ts"
export * from "./IconLibrary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports